import Icon from '../components/Icon.vue'

Icon.register({
  'low-vision': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M569.3 231.6C513 135.9 407.8 72 288 72 259.5 72 231.9 75.6 205.5 82.4L152.8 10.2C145.2-0.6 130.2-3.3 119.4 4.3L106.2 13.5C95.4 21.1 92.7 36.1 100.3 46.9L143.5 105.3C89.4 131.7 40.2 174.7 6.7 231.6 6.7 231.6 6.7 231.6 6.6 231.6-2.1 246.5-2.3 265.2 6.6 280.4 45.1 345.7 106.4 396.2 179.5 421.7L55.3 244.3A272.2-272.2 0 0 0 83.6 208.4L203 379H203L243.7 437A330.1-330.1 0 0 1 322.6 438.2L132.6 166.8A277.6-277.6 0 0 0 171.4 145.2L423.2 501.8C430.8 512.6 445.8 515.3 456.6 507.7L469.8 498.5C480.6 490.9 483.3 475.9 475.7 465.1L432.5 406.7 432.5 406.7C489.7 378.7 537.4 334.6 569.3 280.4A47.9-47.9 0 0 1 569.3 231.6zM390 345.9L371 318.7C395.6 286.1 398.7 242.4 379.8 207V207.1C379.8 230.7 360.6 249.9 336.9 249.9 313.1 249.9 294.1 230.5 294.1 207.1 294.1 183.4 313.3 164.2 336.9 164.2H337C312.2 151 283.4 148.6 257.5 156.6L238.4 129.3C253.8 123.3 270.5 120 288 120 363.2 120 424 180.8 424 256 424 290.5 411.2 322 390 345.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/low-vision.js
// module id = WpOc
// module chunks = 144